import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

declare global {
  interface Window {
    dataLayer: any[];
    gtag?: (...args: any[]) => void;
  }
}

export const CONSENT_STORAGE_KEY = 'fivelens_cookie_consent';
export const CONSENT_CHANGED_EVENT = 'fivelens_cookie_consent_changed';

export const updateGtagConsent = (status: 'granted' | 'denied') => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      ad_storage: status,
      ad_user_data: status,
      ad_personalization: status,
      analytics_storage: status,
    });
  }
};

export const CookieConsent = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!consent) {
      setShow(true);
    } else if (consent === 'granted') {
      updateGtagConsent('granted');
      loadPixels();
    } else if (consent === 'denied' || consent === 'declined') {
      updateGtagConsent('denied');
    }
  }, []);

  const loadPixels = () => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'consent_granted' });
      // GTM, Meta Pixel, and LinkedIn tags would trigger based on this event
    }
  };

  const handleAccept = () => {
    localStorage.setItem(CONSENT_STORAGE_KEY, 'granted');
    window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: 'granted' }));
    updateGtagConsent('granted');
    setShow(false);
    loadPixels();
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_STORAGE_KEY, 'denied');
    window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: 'denied' }));
    updateGtagConsent('denied');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-ink text-ground p-6 z-[100] flex flex-col lg:flex-row items-center justify-between border-t border-rule-3 shadow-2xl">
      <div className="text-sm font-light mb-6 lg:mb-0 max-w-4xl text-center lg:text-left leading-relaxed">
        {t('cookie.desc')}
      </div>
      <div className="flex flex-col sm:flex-row items-center gap-4 shrink-0 w-full sm:w-auto">
        <button onClick={handleDecline} className="text-xs uppercase tracking-widest text-ground/70 hover:text-white transition-colors py-2 px-4 w-full sm:w-auto">
          {t('cookie.decline')}
        </button>
        <button onClick={handleAccept} className="bg-rule-3 text-white hover:text-ink text-xs uppercase tracking-widest font-bold px-8 py-3 hover:bg-white transition-colors w-full sm:w-auto">
          {t('cookie.accept')}
        </button>
      </div>
    </div>
  );
};
